<template>
  <div class="banner">
    <img :src="require('@/assets/images/' + banner+'.png')" />
  </div>
</template>

<script>
export default {
  props: {
    banner: {
      require: false,
      default: "about",
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 80px;
  img {
    width: 100%;
    height: 100%;
    font-size: 0;
    object-fit: cover;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/common/banner.vue